class UpsellProductVariant extends HTMLElement {
  onVariantChangeUnsubscriber = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    this.priceChange();
  }

  init() {
    const variantSelect = this.querySelector('variant-selects');
    if (variantSelect) {
      variantSelect.addEventListener('change', this.handleVariantChange.bind(this));
    }
  }

  get selectedOption() {
    const select = this.querySelector('variant-selects select');
    const selectedOption = select.options[select.selectedIndex];

    return selectedOption;
  }

  priceChange() {
    const selectedOption = this.selectedOption;
    const sourceVariantPrice = selectedOption.getAttribute('data-variant-price');

    const priceElement =
      this.closest('.product-card-wrapper').querySelectorAll('.price-item--regular');

    if (priceElement && sourceVariantPrice) {
      priceElement.forEach((element) => {
        element.innerHTML = sourceVariantPrice;
      });
    } else {
      priceElement.forEach((element) => {
        element.innerHTML = '';
      });
    }
  }

  handleVariantChange(event) {
    const selectedOption = event.target.options[event.target.selectedIndex];
    const productUrl = selectedOption.getAttribute('data-product-url') || this.dataset.url;
    const selectedOptionValues = selectedOption.getAttribute('data-option-value-id');

    if (productUrl) {
      this.renderProductVariant(productUrl, selectedOptionValues);
      this.priceChange();
    }
  }

  renderProductVariant(productUrl, selectedOptionValues) {
    fetch(`${productUrl}?section_id=${this.dataset.section}&option_values=${selectedOptionValues}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceVariantSelect = html.querySelector(
          `[data-section-id="${this.dataset.sectionId}"] variant-selects`
        );

        if (sourceVariantSelect) {
          const currentVariantSelect = this.querySelector('variant-selects');
          if (currentVariantSelect) {
            currentVariantSelect.innerHTML = sourceVariantSelect.innerHTML;
          }

          const selectedVariant = JSON.parse(
            sourceVariantSelect.querySelector('[data-selected-variant]')?.innerHTML
          );

          const productForm = this.querySelector('product-form');
          if (productForm) {
            productForm.querySelector('input[name="id"]').value = selectedVariant.id;
          }

          if (selectedVariant.available) {
            productForm?.toggleSubmitButton(false);
          } else {
            productForm?.toggleSubmitButton(true, window.variantStrings.soldOut);
          }
        }
      });
  }

  disconnectedCallback() {
    if (this.onVariantChangeUnsubscriber) {
      this.onVariantChangeUnsubscriber();
    }
  }
}

customElements.define('upsell-product-variant', UpsellProductVariant);
